import { clearInFlightRequests } from '@/shared/infra/http'
import { makeSupabaseClient } from '@/shared/infra/supabase'
import { clearImpersonation } from './impersonation-store'

export async function endImpersonationClient(): Promise<void> {
  clearImpersonation()
  clearInFlightRequests()
  try {
    await makeSupabaseClient().auth.signOut({ scope: 'local' })
  } catch {
    return
  }
}
